import styled, { css } from 'styled-components';

import { basicCaptionTextStyle, basicSmallTextStyle, Text } from '@dreryk/react-components';

type StyledPatientNameProps = {
   $nowrap: boolean;
};

export const StyledPatientNameText = styled(Text)<StyledPatientNameProps>`
   ${basicSmallTextStyle};

   ${(props) =>
      props.$nowrap &&
      css`
         flex: 1 1;
         overflow: hidden;
         text-overflow: ellipsis;
         white-space: nowrap;
      `}
`;
StyledPatientNameText.displayName = 'StyledPatientNameText';

type StyledEventTimeProps = {
   $hidden: boolean;
};

export const StyledEventTime = styled.div<StyledEventTimeProps>`
   ${basicCaptionTextStyle};

   ${(props) =>
      props.$hidden &&
      css`
         display: none;
      `}
`;
StyledEventTime.displayName = 'StyledEventTime';

type StyledAppointmentsTimetableEventProps = {
   $horizontal: boolean;
};

export const StyledAppointmentsTimetableEvent = styled.div<StyledAppointmentsTimetableEventProps>`
   position: relative;
   cursor: pointer;
   display: flex;
   flex-direction: ${(props) => (props.$horizontal ? 'row' : 'column')};
   gap: 4px;
   padding: ${(props) => (props.$horizontal ? '5px 6px 5px 12px' : '5px 12px')};
   min-height: 100%;
`;
StyledAppointmentsTimetableEvent.displayName = 'StyledAppointmentsTimetableEvent';

type StyledCalendarEventIconsProps = {
   $static: boolean;
};

export const StyledCalendarEventIcons = styled.div<StyledCalendarEventIconsProps>`
   overflow: hidden;
   display: flex;
   gap: 4px;

   ${(props) =>
      !props.$static &&
      css`
         position: absolute;
         bottom: 6px;
         right: 6px;
         height: 16px;
      `}
`;

StyledCalendarEventIcons.displayName = 'StyledCalendarEventActions';
